import React from "react";
import { Handle, Position } from "@xyflow/react";
import styled from "styled-components";
import { Icon, Text } from "~/components-shared";
const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-image: linear-gradient(135deg, hsl(199 89% 48%), hsl(217 91% 60%));
  color: #ffffff;
  border-radius: 20px;
  width: ${_ref => {
  let {
    $width
  } = _ref;
  return $width;
}}px;
  height: ${_ref2 => {
  let {
    $height
  } = _ref2;
  return $height;
}}px;
`;
const SourceNode = _ref3 => {
  let {
    data,
    selected
  } = _ref3;
  const size = 120 + data.intensity * 6;
  return /*#__PURE__*/React.createElement(Wrapper, {
    className: `${selected ? "border-source-end shadow-lg shadow-source-end/50 scale-110" : "border-source-start/30"}`,
    $width: size,
    $height: size
  }, /*#__PURE__*/React.createElement(Icon, {
    src: "webhook",
    scale: 9,
    s: {
      mb: 2
    }
  }), /*#__PURE__*/React.createElement(Text, {
    fontSize: 5,
    weight: "semiBold",
    align: "center"
  }, data.label), /*#__PURE__*/React.createElement(Handle, {
    type: "source",
    position: Position.Right,
    className: "!bg-source-end !border-2 !border-source-start !w-3 !h-3"
  }));
};
export default SourceNode;